<template>
  <div class="wrapper">
    <div class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-33 md-small-size-66 md-xsmall-size-100 md-medium-size-40 mx-auto"
          >
            <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(onReset)">
                <md-card class="md-card-login">
                  <md-card-header class="md-card-header-primary">
                    <h4 class="card-title">{{$t('Set new password')}}</h4>
                  </md-card-header>

                  <md-card-content>
                    <br />

                    <validation-provider vid="password" rules="min:5" v-slot="v" mode="lazy">
                      <md-field class="md-form-group" :class="{'md-invalid md-error' : v.failed}">
                        <md-icon>lock_outline</md-icon>
                        <label class="required">{{ $t('Password') }}</label>
                        <md-input v-model="model.password" type="password" />
                      </md-field>
                      <p class="md-error">
                        <span v-for="error in v.errors" :key="error">{{error}}</span>
                      </p>
                    </validation-provider>

                    <validation-provider
                      vid="confirmPassword"
                      rules="min:5|confirmed:password"
                      v-slot="v"
                      mode="lazy"
                    >
                      <md-field class="md-form-group" :class="{'md-invalid md-error' : v.failed}">
                        <md-icon>lock_outline</md-icon>
                        <label class="required">{{ $t('Confirm password') }}</label>
                        <md-input v-model="model.confirmPassword" type="password" />
                      </md-field>
                      <p class="md-error">
                        <span v-for="error in v.errors" :key="error">{{error}}</span>
                      </p>
                    </validation-provider>
                  </md-card-content>

                  <md-card-actions>
                    <md-button
                      class="md-round md-sm md-primary md-blue-border"
                      type="submit"
                    >{{ $t('reset password') }}</md-button>
                  </md-card-actions>

                  <md-card-actions>
                    <md-button
                      class="md-simple md-link md-sm"
                      @click="onBackToLoginPage"
                    >{{ $t('back to login page') }}</md-button>
                  </md-card-actions>
                </md-card>
              </form>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/util/axios";
import { mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, confirmed, min } from "vee-validate/dist/rules";
import Mixins from "@/plugins/basicMixins";

extend("required", required);
extend("confirmed", confirmed);
extend("min", min);

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "login-page",
  computed: {
    ...mapGetters({ language: "language/current" })
  },
  props: ["token", "username"],
  data() {
    return {
      image: require("@/assets/img/background.png"),

      model: {
        password: null,
        confirmPassword: null
      }
    };
  },
  methods: {
    async onReset() {
      let loader = this.$loading.show();

      try {
        let result = await axios.post("auth/resetPassword", {
          ...this.model,
          token: this.token,
          username: this.username
        });

        this.$swal({
          icon: "success",
          title: this.$t("Done"),
          text: this.$t("Password has been reset")
        });
        this.$router.push({ name: "login" });
      } catch (exception) {
        this.$swal({
          icon: "error",
          title: this.$t("Error"),
          html: this.$t("Invalid token error")
        });
      } finally {
        loader.hide();
      }
    },
    onBackToLoginPage() {
      this.$router.push({ name: "login" });
    }
  },
  watch: {
    language() {
      this.$refs.formValidator.validate();
    }
  }
};
</script>

<style lang="css">
</style>
